<template>
    <el-card class="box">
        <div class="status">
            <slot name="head"></slot>
        </div>
        <slot></slot>
        <div class="footer">
            <slot name="footer"></slot>
        </div>
    </el-card>
</template>

<script>
export default {
    data() {
        return {}
    },
}
</script>

<style lang="scss" scoped>
    .box {
        width: 100%;
        min-height: 131px;
        border: none;
        background-color: #ffffff;
        box-shadow: none;
        padding:0px 24px 24px 24px;
        margin-bottom:20px;
        border-radius: 4px;
        position: relative;

        &:hover {
            background-color: #ffffff9a;
            box-shadow: none;
            box-shadow: 0px 3px 12px 0px  rgba(115, 120, 133, 0.08);
        }

        .status {
            position: absolute;
            top: 0;
            right: 0;
        }

        .footer {
            position: absolute;
            bottom: 6px;
            right: 24px;
        }
    }
</style>